import { Role } from "./roles";

export class User {
    area: string;
    areaId: string;
    dni: string;
    email: string;
    extraHours: number;
    key: string;
    name: string;
    password: string;
    pendingAPs: any; 
    pendingHolidays: any;
    petitions: any;
    phone: string;
    repo: string;
    role: Role = Role.unauthorized;
    state: string;
    
    // pendents d'eliminar
    telefon: string;
}


// WEBPACK FOOTER //
// ./src/models/user.ts